import { Record } from 'immutable';

export const Location = new Record({
	id: null,
	nombre: null,
	provincia: null,
})

export function createLocation(data) {
	return new Location({
		id: Number(data.id) || null,
		nombre: data.nombre,
		provincia: data.provincia
	});
}
